// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","icon":"PrequalRequested_icon__Sxv6n","close":"PrequalRequested_close__2Qs4J"};